<template>
  <line-chart
    class="fill-height"
    :raw-data="periods"
    :chart-value-keys="chartValueKeys"
    x-value="title"
    y-value-prefix="teams[0].team_stats."
    :yaxis="[{min: 0}]"
    :xaxis="{
      labels: {
        rotate: -45
      },
      tickPlacement: 'between'
    }"
    :colors="[ '#b3b3b3', '#008FFB', '#00E396', '#FEB019', '#FF4560']"
    :markers="{ colors: [ '#b3b3b3', '#008FFB', '#00E396', '#FEB019', '#FF4560']}"
    :fill="{ opacity: [0.5, 0.5, 0.5, 0.5, 0.5]}"
    :loading="loading"
  >
    <template v-slot:header>
      <v-card-title class="pa-6 d-flex justify-space-between">
        <div class="subtitle-2 grey--text text--grey-100">
          {{ $t("card_title.hr_zone_analysis") }}
        </div>
        <v-btn
          v-if="removable"
          icon
          style="pointer-events: auto"
          @click="$emit('remove')"
        >
          <v-icon small>
            fal fa-times
          </v-icon>
        </v-btn>
      </v-card-title>
    </template>
  </line-chart>
</template>

<script>
import LineChart from '@/components/charts/LineChart.vue'

export default {
  name: 'HrZonePeriodChart',
  components: { LineChart },
  props: {
    periods: {
      type: Array,
      required: true
    },
    chart: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    removable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    chartValueKeys() {
      return [
        { key: 'ZONE1DR', type: 'bar', label: '1.' + this.$t('hr_variables.regeneration') },
        { key: 'ZONE2DR', type: 'bar', label: '2.' + this.$t('hr_variables.extensive_aerobic_zone') },
        { key: 'ZONE3DR', type: 'bar', label: '3.' + this.$t('hr_variables.intensive_aerobic_zone') },
        { key: 'ZONE4DR', type: 'bar', label: '4.' + this.$t('hr_variables.anaerobic_threshold_zone') },
        { key: 'ZONE5DR', type: 'bar', label: '5.' + this.$t('hr_variables.vo2_max_zone') }
      ]
    }
  }
}
</script>
